module.exports = __webpack_public_path__ + "img/bl-yong.b223242d.jpg";